// ── dailyGame — the ONE clock Cliffhanger and Face-Off both read ───────────────
// MIRRORED in netlify/functions/_shared/dailyGame.cjs (CommonJS, functions can't
// import ESM) and cross-checked by dailyGame.parity.test.js — the same shape as
// streakFreeze.js/streak.cjs. Edit one, you must edit both, or the app's "today"
// and a nudge/digest cron's "today" drift apart (Jason 2026-07-18 had exactly
// this class of bug with the streak math; don't repeat it here).
//
// Both daily games are SHARED dailies on purpose: every player gets the identical
// puzzle/rounds, the leaderboard and "friends solved today" key off one global
// `day` integer, and the emoji share only makes sense if your friend's board was
// the same as yours. That rules out a true per-user local-midnight rollover —
// splitting the day by viewer timezone would mean two friends in different
// timezones are silently on different puzzles at the same moment, which breaks
// the entire premise.
//
// What WAS wrong: the rollover was pinned to literal UTC midnight, which is
// 7-8pm the previous evening across the US (audit 2026-08-30 — "someone playing
// at 8pm Pacific is already on tomorrow's puzzle; someone playing right after
// their own local midnight is still stuck on yesterday's"). Most of NextEp's
// player base is in US timezones (the nightly ops routine itself runs on
// Eastern), so the shared rollover now anchors to US Eastern instead of UTC —
// still one global day for everyone, just at an hour that reads as "midnight"
// for the majority instead of "early evening." A fixed -5h offset (standard
// time) is used year-round rather than tracking DST, so the boundary drifts
// between ~midnight EST and ~1am EDT depending on season — a small, accepted
// imprecision in exchange for not needing a timezone database here.
export const EPOCH = Date.UTC(2026, 0, 1)
export const ROLLOVER_OFFSET_MS = 5 * 3600 * 1000 // 05:00 UTC ≈ midnight ET (standard time)

export const dayNumber = () => Math.floor((Date.now() - EPOCH - ROLLOVER_OFFSET_MS) / 86400000)

// Inverse of dayNumber() — the real-world moment a given day integer's rollover
// begins. Used anywhere a day number needs to render back as a calendar date
// (CaseFile's stamp, TomorrowTeaser's theme lookup, etc.) — hand-rolling
// `EPOCH + day * 86400000` again would silently drop the offset above.
export const dayToDate = (day) => new Date(EPOCH + ROLLOVER_OFFSET_MS + day * 86400000)
